const TaxonomyPermissions = {
  edit: 'taxonomy:edit',
  create: 'taxonomy:create',
  delete: 'taxonomy:delete',
  view: 'taxonomy:view',
}

export default TaxonomyPermissions
